import { ResourceProps } from "react-admin";
import { PaymentShow, PaymentsList } from "./components";

export const affiliatePayoutsResource: Omit<ResourceProps, "name"> = {
  list: PaymentsList,
  show: PaymentShow,
};
